import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rpbegajur: FaireProductEntity = {
  token: "p_7rpbegajur",
  type: "product",
  name: "Cabochon Rose Quartz (Pack of 12)",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl:
    "https://cdn.faire.com/fastly/062cdf24ed4c9e0b90df77a44359151f3ea129f1f873dde0ff94989818bc92cc.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.23,
  description:
    "This pack contains 12 pieces of Cabochon Rose Quartz, each around 1-1.5 inches long. As one of Vrinda's signature offerings, these spiritual stones are carefully selected to support mindfulness and well-being. Ideal for healing and meditational practices, they serve as a symbol of balance, peace, and spiritual connection. Established in 2008, Vrinda is a trusted name in the wellness community, bringing meaningful products to those seeking a sacred living experience.",
  tags: [],
  msrpDollars: 30.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:50.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
